export { Gallery1 } from "./Gallery1";
export { Gallery2 } from "./Gallery2";
export { Gallery3 } from "./Gallery3";
export { Gallery4 } from "./Gallery4";
export { Gallery5 } from "./Gallery5";  
export { Gallery6 } from "./Gallery6";
export { Gallery7 } from "./Gallery7";